import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesAreasDataGrid } from "src/components/views/erp/sales/crm/salesAreas/SalesAreasDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/crm/salesAreas")({
	staticData: { title: i18n.t("sales_areas"), legacyViewKey: "salesAreasView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesAreasDataGrid />;
}
